import {useSelector} from 'src/v2/state/store';

export const useContactSupportUrl = (): string => {
  const sessionId = useSelector((state) => state.id);
  return `https://support.stripe.com/user/contact/email?crypto_payin_session=${sessionId}`;
};
